var clampValue = function (value, limit) { return Math.min(Math.max(value, -limit), limit); };
// The translate is applied after the scale, so the visible shift is scale * translate
export var getClampedZoomPosition = function (position, scale, size) {
    var limitX = (size.width * (scale - 1)) / (2 * scale);
    var limitY = (size.height * (scale - 1)) / (2 * scale);
    return { x: clampValue(position.x, limitX), y: clampValue(position.y, limitY) };
};
